import apiClient from '../apiClient';
import type { BaseResponse } from '../../types/base.dto';
import type {
  ProfitEstimationCalculateRequest,
  ProfitEstimationCalculateResponse,
  ProfitEstimationInitResponse,
} from '../../types/process/order-profit-estimation';

class OrderProfitEstimationAPI {
  private endpoint = '/orders';

  async getInit(orderNo: string): Promise<BaseResponse<ProfitEstimationInitResponse>> {
    const response = await apiClient.get<BaseResponse<ProfitEstimationInitResponse>>(`${this.endpoint}/${orderNo}/profit-estimation`);
    return response.data;
  }

  async calculate(orderNo: string, payload: ProfitEstimationCalculateRequest): Promise<BaseResponse<ProfitEstimationCalculateResponse>> {
    const response = await apiClient.post<BaseResponse<ProfitEstimationCalculateResponse>>(
      `${this.endpoint}/${orderNo}/profit-estimation/calculate`,
      payload
    );
    return response.data;
  }
}

export const orderProfitEstimationApi = new OrderProfitEstimationAPI();

